/**
 * Updated by Daniel on 11/21/2023, Added function to wrap automatically, and changed the font-size by the text.
 */

import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, HostListener, ElementRef } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { TamDashboardActions, TamDashboardEvents } from '../tam-dashboard.model';
import { TamDashboardTileBaseComponent } from '../tam-dashboard-tile.base.component';
import { TamDashboardMetadataTileConfiguration } from './tam-dashboard-metadata-tile.config';
import { FileHelperService } from '../../../services/file-helper.service';

@Component({
    selector: 'tam-dashboard-metadata-tile',
    templateUrl: './tam-dashboard-metadata-tile.component.html',
    styleUrls: ['./tam-dashboard-metadata-tile.component.scss']
})
export class TamDashboardMetadataTileComponent implements OnInit, AfterViewInit, OnDestroy, TamDashboardTileBaseComponent {
    data: any[];

    private _afterViewFeedback$ = new Subject<string>();
    private _config: TamDashboardMetadataTileConfiguration;
    private _destroySubscriptions: Array<Subscription> = [];
    private _fontSizeCalculator: (parentWidth: number, text: string) => any = (parentWidth: number, text: string) => undefined;

    constructor(
        private _cdr: ChangeDetectorRef,
        private _el: ElementRef,
        private _fileHelperService: FileHelperService
    ) { }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this._afterViewFeedback$.next(TamDashboardEvents.TILE_AFTER_VIEW_INIT);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        if (this._config) {
            this._config.destroy();
        }
    }

    downloadFile(item): void {
        this._fileHelperService.downloadFile$.next();
        this._fileHelperService.downloadFileNew(item.file, item.extension, item.serverfilename);
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this._setFontSizeByResize();
    }

    setConfig(config: TamDashboardMetadataTileConfiguration) {
        // modify reason, same as pie chart
        this._config = config;
        this._init();
        return true;
    }

    trackByFn(index) {
        return index;
    }

    private _init() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        this._destroySubscriptions.push(
            this._config.actionSubject$.pipe(
                filter((action: any) => action && action.id === this._config.id),
            ).subscribe(action => this._onSubscribeActions(action)),
            this._afterViewFeedback$.subscribe((payload) => {
                if (payload === TamDashboardEvents.TILE_AFTER_VIEW_INIT) {
                    this._config.feedbackSubject$.next({
                        type: TamDashboardEvents.TILE_AFTER_VIEW_INIT,
                        id: this._config.id
                    });
                }
            })
        );
    }

    private _onSubscribeActions(action) {
        if (action.type === TamDashboardActions.SET_TILE_DATA) {
            if (action.payload === null || action.payload.data === null) {
                this._config.feedbackSubject$.next({
                    type: TamDashboardEvents.TILE_LOADED_DATA,
                    id: this._config.id
                });
            } else {
                this.data = action.payload.data;
                if (this.data) {
                    this.data.forEach(item => {
                        this._fontSizeCalculator = item.fontSizeCalculator;
                        this._setFontSizeByResize(true);
                    });
                }
            }
            this._cdr.detectChanges();
        }
    }

    private _setFontSizeByResize(markSetData = false) {
        setTimeout(() => {
            // grid tile change type to value tile
            if (this._fontSizeCalculator) {
                this.data.forEach(item => {
                    item.fontSize = this._fontSizeCalculator(this._el.nativeElement?.children[0]?.children[0]?.offsetWidth, item.isFileColumn ? item.value.map(value => value.file + value.extension).join(',') : item.value);
                });

                if (markSetData) {
                    this._config.feedbackSubject$.next({
                        type: TamDashboardEvents.TILE_LOADED_DATA,
                        id: this._config.id
                    });
                }
            }
        }, 250);
    }
}
